import { motion } from 'framer-motion';
import './Quote.css';

const wordVariants = {
  hidden: { opacity: 0, y: 20, filter: 'blur(6px)' },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: {
      duration: 0.6,
      ease: [0.16, 1, 0.3, 1],
      delay: i * 0.035,
    },
  }),
};

export default function Quote() {
  const segments = [
    { text: "Hey there! I'm Leo ", highlight: false },
    { text: '— a Full-Stack Engineer', highlight: true },
    { text: ' with a thing for building products from scratch. I currently run ', highlight: false },
    { text: 'Vindey', highlight: true },
    { text: ', build security at ', highlight: false },
    { text: 'KindsSecurity', highlight: true },
    { text: ', previously led product at ', highlight: false },
    { text: 'Lightwork AI', highlight: true },
    { text: ', and occasionally team up with founders to bring ideas to life.', highlight: false },
  ];

  let wordIndex = 0;

  return (
    <motion.section
      className="quote-section"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-60px' }}
    >
      <p className="quote-text">
        {segments.map((segment, segIdx) => {
          const words = segment.text.split(/(\s+)/);
          return words.map((word, wIdx) => {
            if (word.trim() === '') return word;
            const idx = wordIndex++;
            return (
              <motion.span
                key={`${segIdx}-${wIdx}`}
                className={`quote-word ${segment.highlight ? 'quote-word--highlight' : ''}`}
                custom={idx}
                variants={wordVariants}
              >
                {word}
              </motion.span>
            );
          });
        })}
      </p>
    </motion.section>
  );
}
